
<app-header-latest></app-header-latest>
<div class="conatiner">
<section class="pay-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow" style="background:rgba(255,255,255,0.1);color:#fff;border-color:rgba(255,255,255,0.2);">💰 Automated Payroll</div>
      <h1>Payroll <span style="color:#C084FC;">Done Right,</span><br>Every Time.</h1>
      <p>Eliminate manual calculations. Compute salaries, taxes, and deductions automatically — and send payslips in minutes, not days.</p>
      <div style="display:flex;gap:16px;">
        <a href="#" class="btn btn-white">Start Free Trial</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.35);">See Compliance Coverage</a>
      </div>
    </div>
    <div>
      <div class="payslip-card">
        <div class="payslip-header">
          <div><div class="payslip-label">EMPLOYEE</div><div class="payslip-emp">Sarah Jenkins</div></div>
          <div style="text-align:right;"><div class="payslip-label">PERIOD</div><div class="payslip-period">Jan 1 – 31, 2025</div></div>
        </div>
        <div class="payslip-label">NET PAY</div>
        <div class="payslip-amount">$10,750.00</div>
        <div class="payslip-breakdown">
          <div class="pay-line"><span>Base Salary</span><span>+ $13,500.00</span></div>
          <div class="pay-line"><span>Performance Bonus</span><span>+ $1,200.00</span></div>
          <div class="pay-line tax-line"><span>Federal Tax (24%)</span><span>– $2,700.00</span></div>
          <div class="pay-line tax-line"><span>Social Security</span><span>– $950.00</span></div>
          <div class="pay-line tax-line"><span>Healthcare (401k)</span><span>– $300.00</span></div>
          <div class="pay-line total-line"><span>Net Disbursed</span><span>$10,750.00</span></div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>

<!-- ── SECTION 2: PAYROLL CYCLE ────────────────────────────── -->
<section class="payroll-cycle">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⚡ Cycle Automation</span>
      <h2 class="sec-h2">From Input to Payslip<br><span class="gradient-text">in Minutes.</span></h2>
      <p class="sec-sub">NeoHRMZ handles every step of the payroll cycle with zero manual intervention.</p>
    </div>
    <div class="cycle-timeline">
      <div class="cycle-step"><div class="cycle-step__dot">📋</div><div class="cycle-step__title">Review Timesheets</div><div class="cycle-step__desc">Auto-imported attendance & overtime data reviewed for discrepancies.</div></div>
      <div class="cycle-step"><div class="cycle-step__dot">🧮</div><div class="cycle-step__title">Auto-Compute</div><div class="cycle-step__desc">Salaries, deductions, taxes, and bonuses calculated with full audit trail.</div></div>
      <div class="cycle-step"><div class="cycle-step__dot">✅</div><div class="cycle-step__title">Approve & Lock</div><div class="cycle-step__desc">One-click manager approval locks payroll run and prevents edits.</div></div>
      <div class="cycle-step"><div class="cycle-step__dot">💳</div><div class="cycle-step__title">Disburse Instantly</div><div class="cycle-step__desc">Direct bank transfers triggered via secure bank API integrations.</div></div>
      <div class="cycle-step"><div class="cycle-step__dot">📧</div><div class="cycle-step__title">Send Payslips</div><div class="cycle-step__desc">Branded, digital payslips emailed and available in employee self-service.</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 3: COMPLIANCE ───────────────────────────────── -->
<section class="compliance-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🛡️ Compliance</span>
      <h2 class="sec-h2">Built-in Compliance,<br><span class="gradient-text">Global Ready.</span></h2>
      <p class="sec-sub">Stay compliant with local and international tax regulations without any additional setup.</p>
    </div>
    <div class="compliance-grid">
      <div class="compliance-item"><div class="compliance-check">✓</div><div><div class="compliance-title">Federal & State Taxation</div><div class="compliance-desc">Automatic withholding based on W-4 data, updated in real-time for legislative changes.</div></div></div>
      <div class="compliance-item"><div class="compliance-check">✓</div><div><div class="compliance-title">GDPR & Data Privacy</div><div class="compliance-desc">End-to-end encryption for payroll records with role-based access control.</div></div></div>
      <div class="compliance-item"><div class="compliance-check">✓</div><div><div class="compliance-title">Multi-Currency Support</div><div class="compliance-desc">Pay global employees in their local currency with live exchange rate conversion.</div></div></div>
      <div class="compliance-item"><div class="compliance-check">✓</div><div><div class="compliance-title">Audit-Ready Reports</div><div class="compliance-desc">One-click generation of payroll registers, tax summaries, and year-end filings.</div></div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 4: STATS ────────────────────────────────────── -->
<section class="pay-stats-section">
  <div class="container-wrapper">
    <div class="pay-stats-section__grid">
      <div class="pay-stat-block"><div class="pay-stat-block__val">$2.4<span>B+</span></div><div class="pay-stat-block__lbl">Payroll Processed Monthly</div></div>
      <div class="pay-stat-block"><div class="pay-stat-block__val">99.8<span>%</span></div><div class="pay-stat-block__lbl">On-Time Payment Rate</div></div>
      <div class="pay-stat-block"><div class="pay-stat-block__val">140<span>+</span></div><div class="pay-stat-block__lbl">Tax Jurisdictions Covered</div></div>
      <div class="pay-stat-block"><div class="pay-stat-block__val">4<span>min</span></div><div class="pay-stat-block__lbl">Average Payroll Run Time</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 5: INTEGRATIONS ─────────────────────────────── -->
<section class="pay-integrations">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🔌 Bank & Finance Integrations</span>
      <h2 class="sec-h2">Connected to Your<br><span class="gradient-text">Entire Finance Stack</span></h2>
      <p class="sec-sub">Sync payroll with your ERP, accounting software, and banking institutions seamlessly.</p>
    </div>
    <div class="pay-integrations__grid">
      <div class="pay-int-card"><div class="pay-int-card__logo">🏦</div><div class="pay-int-card__name">Stripe</div><div class="pay-int-card__type">Bank Transfer</div></div>
      <div class="pay-int-card"><div class="pay-int-card__logo">📊</div><div class="pay-int-card__name">QuickBooks</div><div class="pay-int-card__type">Accounting</div></div>
      <div class="pay-int-card"><div class="pay-int-card__logo">💼</div><div class="pay-int-card__name">Xero</div><div class="pay-int-card__type">Finance</div></div>
      <div class="pay-int-card"><div class="pay-int-card__logo">🔵</div><div class="pay-int-card__name">SAP</div><div class="pay-int-card__type">ERP</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 6: CTA ──────────────────────────────────────── -->
<section class="pay-cta">
  <div class="container-wrapper">
    <h2 class="pay-cta__h2">Run Payroll Like<br><div class="mt-4">a Pro. Free Trial.</div></h2>
    <p class="pay-cta__p">Get started in under 30 minutes. No credit card required. Full payroll suite included.</p>
    <div class="pay-cta__actions">
      <a href="#" class="btn btn-white">Start Free Trial</a>
      <a href="contact.html" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">Talk to Sales</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>

